<puro-sidebar-navigation [items]="items()" (itemClick)="onItemClick($event)" />
